const storageKey = "token";
export default class AuthStoreService {
    getToken() {
        return localStorage.getItem(storageKey);
    }

    setToken(token) {
        localStorage.setItem(storageKey, token);
    }

    setUserName(name) {
        localStorage.setItem("name", name);
    }
    removeToken() {
        localStorage.removeItem(storageKey);
    }
    setOtpReferenceNumber(token) {
        localStorage.setItem("OTPREFERENCE", token);
    }
    set_RateApprovalList() {
        const token = "rateApprovalListAccess";
        localStorage.setItem("HAS_APPROVALLIST_RATE", token);
    }
    isSignedIn() {
        return !!this.getToken();
    }

    getTokenData() {
        const token = AuthStoreService.getToken();
        if (token) {
            return JSON.parse(atob(token.split(".")[1]));
        }
        return {};
    }

    setUserPages(userPages) {
        localStorage.setItem("UserPages", userPages);
    }
    setUserMenus(userPages) {
        localStorage.setItem("Menus", JSON.stringify(userPages));
    }
    setUserTaskActions(taskActions) {
        localStorage.setItem("TaskActions", taskActions);
    }
    setForcePassword(data) {
        localStorage.setItem("ForcePasswordReset", data);
    }
    getUserPages() {
        return JSON.parse(localStorage.getItem("UserPages"));
    }

    getUserTaskActions() {
        return JSON.parse(localStorage.getItem("TaskActions"));
    }

    logOut() {
        localStorage.clear();
    }
}
